import { useSearchParams } from 'react-router'

import type { UrlParamCodec } from '@/lib/url-params/codecs'

export function useUrlParam<T>(
  key: string,
  codec: UrlParamCodec<T>,
): [T | null, (value: T | null) => void] {
  const [searchParams, setSearchParams] = useSearchParams()

  const raw = searchParams.get(key)
  const value = raw ? codec.decode(raw) : null

  const setValue = (next: T | null) => {
    setSearchParams(
      (prev) => {
        const params = new URLSearchParams(prev)
        if (next === null) {
          params.delete(key)
        } else {
          params.set(key, codec.encode(next))
        }
        return params
      },
      { replace: true },
    )
  }

  return [value, setValue]
}
